import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { actionBinder } from '../../utils/actionBinder';

import { requestSlice } from './requestSlice';

export const useResetStoreData = <P>({ requestId }: { requestId: string }) => {
    const dispatch = useDispatch();

    const makeStoreReset = useMemo(() => {
        const boundMakeRequest = actionBinder(requestSlice.actions.resetStoreData, requestId);

        return (value: P) =>
            dispatch(
                boundMakeRequest({
                    value,
                }),
            );
    }, [dispatch, requestId]);

    return [makeStoreReset];
};

export const useResetMultipleStoreData = ({ requestIds }: { requestIds: Array<string> }) => {
    const dispatch = useDispatch();

    const makeMultiReset = useMemo(() => {
        const resetFunctionsArr = requestIds.map((requestId) => {
            const boundMakeRequest = actionBinder(requestSlice.actions.resetStoreData, requestId);

            return () =>
                dispatch(
                    boundMakeRequest({
                        undefined,
                    }),
                );
        });

        return () => {
            resetFunctionsArr.forEach((requestFn) => {
                requestFn();
            });
        };
    }, [dispatch, requestIds]);

    return [makeMultiReset];
};
